/*
 * @Author: wyh
 * @Date: 2019-06-13 17:26:47
 * @Last Modified by: wyh
 * @Last Modified time: 2019-07-17 14:21:12
 * @Description: 公共导入到app.module中的内容
 */
import { HttpClientModule } from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { IonicStorageModule } from "@ionic/storage";

/** native plugins */
import { Device } from "@ionic-native/device";
import { Network } from "@ionic-native/network";
import { Badge } from "@ionic-native/badge";
import { LocalNotifications } from "@ionic-native/local-notifications";
import { Keyboard } from "@ionic-native/keyboard";
import { BackgroundMode } from "@ionic-native/background-mode";

/** third plugins */
// import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { SuperTabsModule } from "ionic2-super-tabs";
import { IonicImageViewerModule } from "ionic-img-viewer";

/** services */
import {
  GlobalState,
  EventService,
  RouterService,
  StorageService,
  httpInterceptorProviders,
  DialogService,
  RequestService,
  LoadingService,
  LoggerService,
  PinYinProvider,
  SaveToastService,
  CreateImage,
  TranslateLoaderService,
  Utils,
} from "../services/common";
import { EncryptionSerProvider } from "../services/common/encryption";
import { FingerPrintHelper } from "../services/common/fingerprint-helper";
import { CacheDataService } from "../services/business/cache-data/cache-data.service";
import { NewsService } from "../services/business/news/news.service";
import { ModelTemService } from "../services/business/model-tem/model-tem.service";
import { AppConfiguration } from "../config";
import { DateUtilProvider } from "../services/common/date-util";
import { CalendarModule } from "../shared/calendar/calendar.module";

// export function createTranslateLoader(http: HttpClient) {
//     return new TranslateHttpLoader(http, './assets/i18n/', '/index.js');
// }

export const MODULES = [
  SuperTabsModule.forRoot(),
  IonicStorageModule.forRoot(),
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useClass: TranslateLoaderService,
      // useFactory: (createTranslateLoader),
      // deps: [HttpClient]
    },
  }),
  // MultiPickerModule,
  HttpClientModule,
  ReactiveFormsModule,
  CalendarModule,
  IonicImageViewerModule,
];

export const PROVIDERS = [
  Device,
  Network,
  Badge,
  LocalNotifications,
  Keyboard,
  BackgroundMode,
  RouterService,
  StorageService,
  AppConfiguration,
  GlobalState,
  EventService,
  httpInterceptorProviders,
  DialogService,
  RequestService,
  LoadingService,
  LoggerService,
  EncryptionSerProvider,
  CacheDataService,
  NewsService,
  ModelTemService,
  FingerPrintHelper,
  DateUtilProvider,
  PinYinProvider,
  SaveToastService,
  Utils,
  CreateImage,
];



// WEBPACK FOOTER //
// ./src/app/app.imports.ts